import { Location } from "react-router-dom";
import LevelSection from "./components/LevelSection/LevelSection";
import SourceSection from "./components/SourceSection/SourceSection";
import TopicSection from "./components/TopicSection/TopicSection";
import MyExercisesSection from "./components/MyExercisesSection/MyExercisesSection";

type Props = {
  location: Location;
};

export default function ExerciseListSidePanel(props: Props) {
  return (
    <>
      <LevelSection location={props.location} />
      {/* TODO Recommended for Student */}
      <SourceSection location={props.location} />
      <TopicSection location={props.location} />
      <MyExercisesSection location={props.location} />
    </>
  );
}
